import React from "react";
import { Collapse } from "react-bootstrap";
import TappaCard from "./TappaCard";
import AddGiornoCard from "./AddGiornoCard";

// Status mapping for colors and names
export const mapStatus = {
    1: { name: "Pagato", color: "#A9DE5B" },
    2: { name: "Annullato", color: "#FF1400" },
    3: { name: "In attesa", color: "#5552f3" },
    4: { name: "Non pagato", color: "#DE8900" },
    5: { name: "In attesa di conferma", color: "#DE8900" },
};

const PrenotazioniTable = ({
    prenotazioniAll,
    open,
    setOpen,
    loader,
    prepareUpdatePrenotazione,
    prepareInfoPrenotazione,
    prepareAddGiorno
}) => {
    if (loader) {
        return (
            <div className="alloggi" style={{ marginTop: "30px", paddingBottom: "60px", borderRadius: "25px", width: "100%" }}>
                <div style={{ textAlign: "center", paddingTop: "200px" }}>
                    <img src="/loader.gif" style={{ borderRadius: "100%" }} alt="" />
                </div>
            </div>
        );
    }

    return (
        <div className="alloggi" style={{ marginTop: "30px", paddingBottom: "60px", borderRadius: "25px", width: "100%" }}>
            <div
                style={{
                    width: "100%",
                    paddingLeft: "23px",
                    paddingRight: "23px",
                    fontWeight: "600",
                    fontSize: "1.1em",
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "10px"
                }}
                className="row"
            >
                <div className="col-1">Id</div>
                <div className="col-2">Utente</div>
                <div className="col-2">Cliente</div>
                <div className="col-1">Stato</div>
                <div className="col-1">Totale</div>
                <div className="col-2">Email Cliente</div>
                <div className="col-1">ID Ordine</div>
                <div className="col-2"></div>
            </div>

            <div className="row prenotazioni" style={{ width: "100%" }}>
                {prenotazioniAll?.data?.map((cammino) => (
                    <div key={cammino.id}>
                        <div className="tr-white" style={{ width: "100%" }}>
                            <div scope="row" style={{ width: "100%", paddingLeft: "23px", paddingRight: "23px", display: "flex", alignItems: "center" }}>
                                <div className="col-1" style={{ paddingLeft: "0px", fontSize: "1.1em" }}>
                                    {cammino.id}
                                </div>
                                <div
                                    style={{
                                        fontWeight: "700",
                                        fontSize: "1.1em"
                                    }}
                                    className="col-2"
                                >
                                    {cammino.user.nome} {cammino.user.cognome}
                                </div>
                                <div
                                    style={{
                                        fontWeight: "600",
                                        fontSize: "1.0em",
                                        color: "#333"
                                    }}
                                    className="col-2"
                                >
                                    {cammino.cliente_formatted || '-'}
                                </div>
                                <div
                                    style={{
                                        fontWeight: "700",
                                        fontSize: "1.1em",
                                        color: cammino.status_color || (
                                            cammino.computed_status === 'CHIUSO' ? '#A9DE5B' : '#5552f3'
                                        )
                                    }}
                                    className="col-1"
                                >
                                    {cammino.computed_status.charAt(0).toUpperCase() +
                                        cammino.computed_status.slice(1).toLowerCase()}
                                </div>
                                <div
                                    style={{
                                        fontWeight: "300",
                                        fontSize: "1.1em"
                                    }}
                                    className="col-1"
                                >
                                    {cammino.tappe
                                        .reduce(
                                            // parseFloat: i prezzi sono DECIMAL e senza conversione
                                            // una somma di stringhe diventa "017.0017.00".
                                            // toFixed: evita code binarie tipo 79.94999999999999.
                                            (acc, tappa) =>
                                                acc + (parseFloat(tappa.costo_prenotazione_singola) || 0),
                                            0
                                        )
                                        .toFixed(2)}{" "}
                                    €
                                </div>
                                <div
                                    style={{
                                        fontWeight: "400",
                                        fontSize: "0.9em",
                                        color: "#666"
                                    }}
                                    className="col-2"
                                >
                                    {cammino.email_cliente || '-'}
                                </div>
                                <div
                                    style={{
                                        fontWeight: "500",
                                        fontSize: "0.9em",
                                        color: "#666"
                                    }}
                                    className="col-1"
                                >
                                    {cammino.id_ordine || '-'}
                                </div>

                                <div
                                    className="col-2"
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        position: "relative",
                                    }}
                                >
                                    {open !== cammino.id && (
                                        <button
                                            onClick={() => setOpen(cammino.id)}
                                            aria-controls="example-collapse-text"
                                            aria-expanded={open === cammino.id}
                                            className="btn-prenotazione"
                                            style={{
                                                color: "#B1B1B1",
                                                fontWeight: "600",
                                                fontSize: "1.1em",
                                                border: "1px solid #B1B1B1",
                                                borderRadius: "15px",
                                                backgroundColor: "transparent",
                                                height: "48px",
                                            }}
                                        >
                                            Dettagli
                                        </button>
                                    )}
                                    {open === cammino.id && (
                                        <button
                                            onClick={() => setOpen(false)}
                                            aria-controls="example-collapse-text"
                                            aria-expanded={open === cammino.id}
                                            className="btn-prenotazione btn-prenotazione1"
                                            style={{
                                                color: "#ffffff",
                                                fontWeight: "600",
                                                fontSize: "1.1em",
                                                border: "none",
                                                borderRadius: "15px",
                                                backgroundColor: "#FF9D00",
                                                height: "48px",
                                            }}
                                        >
                                            Chiudi
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>

                        <Collapse in={open === cammino.id}>
                            <div id="example-collapse-text" style={{ width: "100%", padding: "10px 20px" }}>
                                <div style={{ display: "flex", flexWrap: "wrap", width: "100%", gap: "15px" }}>
                                    {cammino.tappe?.length > 0 &&
                                        cammino.tappe
                                            ?.sort(
                                                (a, b) =>
                                                    new Date(a.data_prenotazione) -
                                                    new Date(b.data_prenotazione)
                                            )
                                            .map((tappa, index) => (
                                                <TappaCard
                                                    key={tappa.id}
                                                    tappa={tappa}
                                                    index={index}
                                                    mapStatus={mapStatus}
                                                    onInfoClick={() => prepareInfoPrenotazione(tappa, index)}
                                                    onUpdateClick={() => prepareUpdatePrenotazione(tappa, cammino)}
                                                />
                                            ))}

                                    <AddGiornoCard
                                        cammino={cammino}
                                        onAddClick={() => prepareAddGiorno(cammino.id, cammino.user?.id)}
                                    />
                                </div>
                            </div>
                        </Collapse>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PrenotazioniTable;